(function() {
    'use strict';
    angular.module('elogbooks.admin.site-relationships', []);
})();
